import { InfoTwoTone } from "@mui/icons-material";

export const SummaryTabHeader = () => {
  return (
    <span style={{ display: "" }}>
      <InfoTwoTone /> <span style={{ verticalAlign: "super" }}>Summary</span>
    </span>
  );
};
